import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Sidebar } from "@/admin/components/Sidebar";
import { Topbar } from "@/admin/components/Topbar";

export function AdminLayout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="admin-shell admin-grid-pattern px-4 py-4 sm:px-6 lg:px-8">
      <div className="mx-auto grid min-h-[calc(100vh-2rem)] max-w-7xl gap-4 lg:grid-cols-[280px_minmax(0,1fr)]">
        <div className="hidden lg:block">
          <Sidebar />
        </div>

        {menuOpen ? (
          <div className="fixed inset-0 z-40 bg-[#07143d]/40 backdrop-blur-sm lg:hidden">
            <div className="h-full w-[280px] p-4">
              <Sidebar onNavigate={() => setMenuOpen(false)} />
            </div>
            <button
              type="button"
              className="absolute inset-0 -z-10 h-full w-full cursor-default"
              onClick={() => setMenuOpen(false)}
              aria-label="Close navigation"
            />
          </div>
        ) : null}

        <main className="flex min-w-0 flex-col gap-4">
          <Topbar onMenuClick={() => setMenuOpen(true)} />
          <Outlet />
        </main>
      </div>
    </div>
  );
}